import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['addButton', 'secondTier'];

  declare addButtonTarget: HTMLButtonElement;

  declare secondTierTarget: HTMLElement;

  addTier() {
    this.addButtonTarget.classList.add('u-displayNone');
    this.secondTierTarget.classList.remove('u-displayNone');

    const yesOption = document.getElementById(
      'compliance_discretionary_match_questionnaire_additional_discretionary_match_option_yes'
    ) as HTMLInputElement;
    yesOption.checked = true;
  }

  removeTier() {
    this.secondTierTarget.classList.add('u-displayNone');
    this.addButtonTarget.classList.remove('u-displayNone');

    const noOption = document.getElementById(
      'compliance_discretionary_match_questionnaire_additional_discretionary_match_option_no'
    ) as HTMLInputElement;
    noOption.checked = true;

    const tier2Fields = this.secondTierTarget.querySelectorAll('input');
    tier2Fields.forEach(field => {
      field.value = '';
    });
  }
}
